import { reactive, toRefs } from "vue";

const layoutConfig = reactive({
  activeMenuItem: null,
});

const useLayout = () => {
  const setActiveMenuItem = (item) => {
    layoutConfig.activeMenuItem = item.value || item;
  };

  return {
    layoutConfig: toRefs(layoutConfig),
    setActiveMenuItem,
  };
};

export { useLayout };
